import axios from '../../utils/axios.js'

export const load = (query) => axios.setAxiosGetPromise('place/getPlaceTree', query)

// export const byId = (id) => axios.setAxiosGetPromise('place/findOne?_id=' + id)

export const byId = (query) => axios.setAxiosGetPromise('place/findOne', query)

export const find = (query) => axios.setAxiosGetPromise('place/find', query)

export const findRegionWidthFeature = (query) => axios.setAxiosGetPromise('place/findRegionWidthFeature', query)

export const add = (options) => axios.setAxiosPostPromise('place/addOne', options)

export const deleteTree = (query) => axios.setAxiosDeletePromise('place/deleteOne', query)

export const updateTree = (options) => axios.setAxiosPutPromise('place/updateOne', options)

export const tenantConfig = () => axios.setAxiosGetPromise('tenantConfig/getTenantConfig')

export const moveTree = (options) => axios.setAxiosPutPromise('place/drag', options)

export const isExistUseSpace = (query) => axios.setAxiosGetPromise('place/isExistUseSpace', query)

export const getAreaCode = (query) => axios.setAxiosGetPromise('place/areaCodeTree', query)



// WEBPACK FOOTER //
// ./src/services/system/place.js